__webpack_require__.p = "/offer-candidate/referrals-hub/";